import React from 'react'
import Color from './EditorProperties/Color'
import Fonts from './EditorProperties/Fonts'
import FontSize from './EditorProperties/FontSize'
import FontStyle from './EditorProperties/FontStyle'
import LineHeight from './EditorProperties/LineHeight'
import Position from './EditorProperties/Position'
import StrokeWidth from './EditorProperties/StrokeWidth'
import Transform from './EditorProperties/Transform'


const TextEditor = () => {

  return (
    <div className='text-editor'>
      <div className='text-editor-group'>
        <Color />
        <Transform />
        <Position />
        <StrokeWidth />
      </div>
      <div className='text-editor-group'>
        <Fonts />
        <FontSize />
        <LineHeight />
      </div>
      <div className='text-editor-group'>
        <FontStyle />
      </div>
    </div>
  )
}

export default TextEditor